import { timeSheetsListingStore } from '@/app/features/time-sheets/features/time-sheets-listing/time-sheets-listing.store';
import { timeSheetDetailsStore } from '@/app/features/time-sheets/features/time-sheet-details/time-sheet-details.store';

export const timeSheetsStore = {
  modules: {
    timeSheetsListingState: timeSheetsListingStore,
    timeSheetDetailsState: timeSheetDetailsStore
  }
};
